module.exports = __webpack_public_path__ + "static/media/sprout-solution-logo.84cdcd9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/billing-icons/sprout-solution-logo.png
// module id = 1273
// module chunks = 17